import {
  Stack as MantineStack,
  type StackProps as MantineStackProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type StackProps = CoreComponentProps<MantineStackProps, 'div'>;

export function Stack({ testId, view = "all", ...rest }: StackProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineStack data-testid={testId} {...rest} />;
}
